import React, { useEffect, useState } from 'react'
import { TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'
import { setPageTitle, TopicPctCorrectSummary, useStores } from '@trivie/core'
import { ProfileCards, TopicStats, color, iconLeaderboard, SvgIcon } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'
import { useHistory } from 'react-router-dom'
import { UserApi } from '@trivie/core/src/services/api-objects/UserApi'
import { Text } from '@trivie/ui-mobile/components/text'
import { HistoryScreen } from '../history-screen'

export const StatsScreen = observer(() => {
  const { userStore, libraryStore, leaderboardStore } = useStores()
  const { enterpriseTier, getGameStats, stats, levelAndPoints, user } = userStore
  const { getTopicsForUser, topics } = libraryStore
  const { getLeaderboards, allTimeUserLeaderboard, monthlyUserLeaderboard } = leaderboardStore

  const [topicGaps, setTopicGaps] = useState<null | Array<Instance<typeof TopicPctCorrectSummary>>>(
    [],
  )

  const history = useHistory()

  const leaderboardsEnabled =
    (user?.workspace_settings?.user_leaderboard_daily_enabled ||
      user?.workspace_settings?.user_leaderboard_weekly_enabled ||
      user?.workspace_settings?.user_leaderboard_monthly_enabled ||
      user?.workspace_settings?.user_leaderboard_alltime_enabled) &&
    !user?.workspace_settings?.gdpr_enabled

  const [loadingTopicStats, setLoadingTopicStats] = useState(true)
  const [loadingGameStats, setLoadingGameStats] = useState(true)

  const goToTopic = (data: Instance<typeof TopicPctCorrectSummary>) => {
    const topic = topics?.filter((f) => f.topic.topic_id === data.topic_id)[0]
    if (topic) {
      history.push(
        `/library/topic?assignment_id=${topic.metadata.assignment_id}&topic_id=${topic.topic.topic_id}&path_id=${topic.metadata.path_id}&content_user_id=${topic.metadata.content_user_id}`,
      )
      setPageTitle(`${data.title} - ${process.env.REACT_APP_SITE_TITLE}`)
    } else {
      history.push(`/library`)
    }
  }

  useEffect(() => {
    gaterDataForTabStats()
  }, [])

  const gaterDataForTabStats = () => {
    if (user) {
      loadLeaderboardData()
      setLoadingGameStats(true)
      getGameStats(user.id).then(() => {
        setLoadingGameStats(false)
      })
      if (enterpriseTier) {
        setLoadingTopicStats(true)
        UserApi.getUserTopicGaps(user.id).then((response) => {
          if (response.ok && response.data) {
            setTopicGaps(response.data.topics)
            setLoadingTopicStats(false)
          }
        })
        getTopicsForUser(user.id)
      }
    }
  }
  const goToLeaderboard = () => history.push('/play/leaderboards')

  const loadLeaderboardData = async () => {
    if (user?.workspace_settings?.user_leaderboard_alltime_enabled)
      await getLeaderboards('all_time')
  }

  return (
    <>
      {!enterpriseTier ? (
        <>
          {leaderboardsEnabled && (
            <TouchableOpacity
              onPress={goToLeaderboard}
              style={{ marginLeft: 0, flex: 1, marginBottom: 20, height: 76, borderRadius: 16 }}
            >
              <View style={NAV_GRADIENT}>
                <View style={{ alignSelf: 'center', paddingTop: 17 }}>
                  <SvgIcon size={32} viewBox="0 0 32 32" src={iconLeaderboard} />
                </View>
                <Text variant="body2Emphasized" tx="Leaderboard.header" style={TOP_NAV_LABEL} />
              </View>
            </TouchableOpacity>
          )}
          <div style={{ margin: 2 }}>
            <ProfileCards
              loadingRecall={loadingGameStats}
              loadingStats={loadingGameStats}
              hideLeaderboard={!enterpriseTier}
              levelAndPoints={levelAndPoints}
              stats={stats}
              leaderboardsEnabled={leaderboardsEnabled}
            />
          </div>
          <ProfileCards
            leaderboardData={allTimeUserLeaderboard?.filter((f) => f.user_id === user?.id)[0]}
            enterpriseTier={enterpriseTier}
            hideQuizzes
            levelAndPoints={null}
            leaderboardsEnabled={leaderboardsEnabled}
            stats={stats}
          />
          <Text
            uppercase
            variant="body2Medium"
            style={{ marginBottom: 10, color: color.shade50 }}
            text="History"
          />
          <HistoryScreen />
        </>
      ) : (
        <>
          <div style={{ margin: 2 }}>
            <ProfileCards
              loadingRecall={loadingGameStats}
              loadingStats={loadingGameStats}
              hideLeaderboard={!enterpriseTier}
              levelAndPoints={levelAndPoints}
              stats={stats}
              leaderboardData={allTimeUserLeaderboard?.filter((f) => f.user_id === user?.id)[0]}
              leaderboardsEnabled={leaderboardsEnabled}
            />
          </div>
          <div style={{ margin: 2 }}>
            <TopicStats
              topics={topics}
              loading={loadingTopicStats}
              stats={topicGaps}
              onPress={goToTopic}
            />
          </div>
        </>
      )}
    </>
  )
})

const NAV_GRADIENT: ViewStyle = {
  height: 76,
  borderRadius: 16,
  justifyContent: 'center',
  paddingBottom: 12,
  backgroundColor: color.white,
  borderWidth: 1,
  borderColor: '#EFF0F6',
}
const TOP_NAV_LABEL: TextStyle = {
  paddingTop: 6,
  lineHeight: 14.52,
  textAlign: 'center',
  color: 'rgba(0,0,0,0.5)',
}
